export default __webpack_public_path__ + "static/FavoriteHeader-ad28d6639e0e1ee6bce19e6504aa3b90.jpg";